<script setup lang="ts">
defineProps<{ modelValue: string }>()
defineEmits<{ 'update:modelValue': [value: string] }>()
</script>

<template>
  <!--
    Honeypot. Visually hidden, off-screen, not display:none and not type=hidden
    (modern bots skip both). aria-hidden + tabindex=-1 so screen readers and
    keyboard users skip it. Real users never fill it; spam scripts often do.
  -->
  <div class="hp" aria-hidden="true">
    <label>
      Website
      <input
        type="text"
        name="website_extra"
        :value="modelValue"
        tabindex="-1"
        autocomplete="off"
        @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      />
    </label>
  </div>
</template>

<style scoped>
.hp {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
</style>
